/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import styled from "styled-components"

import Home from "./View/home/Home"
import HomeWEB3 from "./View/homeWEB3/Home"
import ResetCSS from "@/common/assets/css/style"
import Questions from "@/containers/MoneyFortune/View/questions/Questions"
import QuestionsWEB3 from "@/containers/MoneyFortune/View/questionsWEB3/Questions"
import CompleteQA from "@/containers/MoneyFortune/View/completeQA/CompleteQA"
import CompleteQAWEB3 from "@/containers/MoneyFortune/View/completeQAWEB3/CompleteQA"
import Result from "@/containers/MoneyFortune/View/result/Result"
import ResultWEB3 from "@/containers/MoneyFortune/View/resultWEB3/Result"
import MetaData from "@/common/components/MetaData"
import ResultCardWEB3 from "./View/resultWEB3/ResultCard"
import { useRouter } from "next/router"

export default function MoneyFortune({
  QuestionsData,
  ResultDate,
  API,
  test,
  GetAndShare,
  resultRoleJudge,
  getTraitId,
  customFor
}) {
  const _router = useRouter()
  const [marks, setMarks] = useState([])
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState(
    GetAndShare.completeType.includes("email") === false ? "123@test.com" : ""
  )
  const [result, setResult] = useState("")
  const [page, setPage] = useState(1)
  const [summary1, setSummary1] = useState(0)
  const [summary2, setSummary2] = useState(0)
  const [AnswerInfo, setAnswerInfo] = useState({
    data: {
      name: "",
      phone: "",
      result: "",
      Answers: [],
      email: ""
    }
  })

  const nextPage = () => {
    setPage(pre => pre + 1)
  }

  const summaryCount = () => {
    marks.map(({ mark1 }) => setSummary1(num => num + mark1))
    marks.map(({ mark2 }) => setSummary2(num => num + mark2))
  }

  const reset = () => {
    setMarks([])
    setName("")
    setPage(1)
    setSummary1(0)
    setSummary2(0)
    setAnswerInfo({ name: "", phone: "", result: "", Answers: [] })
    setPhone("")
    setResult("")
    setEmail("")
  }

  const setAnswerInfoHandler = () => {
    let marksContents = []
    marks.map(({ content }) => {
      marksContents = [...marksContents, { Answer: content }]
    })

    setAnswerInfo({
      data: {
        name: name,
        phone: phone,
        result: result,
        Answers: marksContents,
        email: email.length > 3 ? email : "noemail@mail.com"
      }
    })
  }

  useEffect(() => {
    if ((page === 1 || page === 2 || page === 3) && !test) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }
  }, [page])

  const saveAnswerInfoToAPI = () => {
    onSubmit(AnswerInfo)
  }

  const onSubmit = async data => {
    try {
      const response = await fetch(GetAndShare.APIPOST, {
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" }
      }).then(res => res.json())
      if (response?.code === 0 || response?.code === 4006)
        if (response?.code === 0) console.log("response success", response)
    } catch (error) {
      window.alert("Something went wrong. Please try again.")
    }
    console.log("data post complete", data)
  }

  //  以下是快速測試用的-------------------------
  const [resultPageData, setResultPageDate] = useState({})
  useEffect(() => {
    const resultfilter = ResultDate.filter(value => {
      return value.roleID === "鼓吹者"
    })[0]

    setResultPageDate(resultfilter)
  }, [])
  //  以上是快速測試用的-------------------------

  const HomeCustomBy = who => {
    switch (who) {
      case "WEB3Plus":
        return <HomeWEB3 page={page} setPage={setPage} />
      default:
        return <Home page={page} setPage={setPage} />
    }
  }
  const QACustomBy = who => {
    switch (who) {
      case "WEB3Plus":
        return (
          <QuestionsWEB3
            data={QuestionsData}
            marks={marks}
            setMarks={setMarks}
            page={page}
            setPage={nextPage}
            summaryCount={summaryCount}
            customFor={customFor}
          />
        )
      default:
        return (
          <Questions
            data={QuestionsData}
            marks={marks}
            setMarks={setMarks}
            page={page}
            setPage={nextPage}
            summaryCount={summaryCount}
            customFor={customFor}
          />
        )
    }
  }
  const CompleteCustomBy = who => {
    switch (who) {
      case "WEB3Plus":
        return (
          <CompleteQAWEB3
            setName={setName}
            page={page}
            name={name}
            setPage={setPage}
            summaryCount={summaryCount}
            GetAndShare={GetAndShare}
            setEmail={setEmail}
            email={email}
            customFor={customFor}
          />
        )
      default:
        return (
          <CompleteQA
            setName={setName}
            page={page}
            name={name}
            setPage={setPage}
            summaryCount={summaryCount}
            GetAndShare={GetAndShare}
            setEmail={setEmail}
            email={email}
            customFor={customFor}
          />
        )
    }
  }
  const ResultCustomBy = who => {
    switch (who) {
      case "WEB3Plus":
        return (
          <ResultWEB3
            data={ResultDate}
            peopleName={name}
            page={page}
            setPage={setPage}
            phone={phone}
            setResult={setResult}
            setPhone={setPhone}
            summary1={summary1}
            summary2={summary2}
            reset={reset}
            API={API}
            GetAndShare={GetAndShare}
            setAnswerInfoHandler={setAnswerInfoHandler}
            setAnswerInfo={setAnswerInfo}
            resultRoleJudge={resultRoleJudge}
            saveAnswerInfoToAPI={saveAnswerInfoToAPI}
            getTraitId={getTraitId}
          />
        )
      default:
        return (
          <Result
            data={ResultDate}
            peopleName={name}
            page={page}
            setPage={setPage}
            phone={phone}
            setResult={setResult}
            setPhone={setPhone}
            summary1={summary1}
            summary2={summary2}
            reset={reset}
            API={API}
            GetAndShare={GetAndShare}
            setAnswerInfoHandler={setAnswerInfoHandler}
            resultRoleJudge={resultRoleJudge}
            saveAnswerInfoToAPI={saveAnswerInfoToAPI}
            getTraitId={getTraitId}
          />
        )
    }
  }
  return (
    <Wrapper>
      <MetaData
        title={GetAndShare.OGtitle}
        description="超神準心理測驗，投資賺錢機會立刻知道，本次的心理測驗將解析你的內心投資性格，透過科學方式，發掘未知的自己，還可以免費拿測驗結果的（Non-fungible token）NFT，藉由區塊鏈技術，使每個NFT都擁有一串獨一無二的編號，are-you-the-next-satoshi ?"
        url={GetAndShare.OGurl}
        image={GetAndShare.OGimg}
      />

      <ResetCSS />
      {page === 1 && HomeCustomBy(customFor)}
      {page === 2 || test ? QACustomBy(customFor) : ""}
      {page === 3 || test ? CompleteCustomBy(customFor) : ""}
      {page === 4 && ResultCustomBy(customFor)}
      {/* 以下是快速測試用的 */}
      {test && (
        <ResultCardWEB3
          roleID={resultPageData.roleID}
          key={resultPageData.roleID}
          name={resultPageData.name}
          AKA={resultPageData.AKA}
          chance={resultPageData.chance}
          saying={resultPageData.saying}
          summary={resultPageData.summary}
          analysis={resultPageData.analysis}
          investment={resultPageData.investment}
          befit={resultPageData.befit}
          img={resultPageData.img}
          resultImg={resultPageData.resultImg}
          setAnswerInfoHandler={setAnswerInfoHandler}
          GetAndShare={GetAndShare}
          resultRoleJudge={resultRoleJudge}
          saveAnserInfoToAPI={saveAnswerInfoToAPI}
        />
      )}
      {/* <ButtonWrapper onClick={saveAnswerInfoToAPI}>
        按這邊傳送 API　
      </ButtonWrapper> */}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 100vh;
  overflow-x: hidden;
  * {
    ::-webkit-scrollbar-thumb {
      background: #00fff0;
      border-radius: 5px;
    }
    ::-webkit-scrollbar {
      width: 2px;
      background-color: none;
    }
  }
`
